import { StyledButtonWrapper } from "../Buttons";
import { DefaultLabel } from "./DefaultLabel";

export const ButtonLabel = StyledButtonWrapper(DefaultLabel);
